import { createFileRoute } from '@tanstack/react-router';
import UserLayout from '@components/layout/UserLayout.tsx';
import ShoppingListsView from '@features/shopping-list/list/ShoppingListsView.tsx';

const Component = () => {
  return (
    <UserLayout>
      <div className={'max-w-[1200px] mx-auto'}>
        <ShoppingListsView />
      </div>
    </UserLayout>
  );
};

export const Route = createFileRoute('/c/$orgId/$portalId/shopping-list/')({
  component: Component,
});
